import { EMenuType, ERoleType } from './enum'
import { IQueryParams, IPagination } from './common'

enum EStatus {
  Normal = 'normal',
  Freeze = 'freeze',
}

export class Role {
  id: string
  roleDesc: string
  roleId: number
  roleName: string
  roleType: number
  status: EStatus
  menus: IMenu[]
  insCodes: string[]
  creatorId?: string
  creatorName?: string
}

export interface IMenu {
  ordinal?: number
  level?: number // èåçº§å«
  menuId: number
  menuName: string
  menuStatus: EMenuType
  menuUri: string
  menuIcon?: string
  menuDesc?: string
  menuState?: string // èå Stateï¼å¯¹åºå° AngularJS çè·¯ç±åç§°
}

export interface IMenuOrdinal {
  menuId: number
  level: number // èåçº§å«
  ordinal: number
}

export interface IRoleUpdate {
  roleName: string
  roleType: number
  roleDesc: string
  insCodes: string[]
  menus?: number[]
}

export interface IRoleQueryParams extends IQueryParams {
  roleId?: number
  roleName?: string
  status?: string
  insCode?: string
  roleType?: number
}

export interface IRolePagination extends IPagination {
  data: Role[]
}

export interface IRoleCreateFormData {
  roleName?: string
  insCode?: any
  roleType?: ERoleType
  roleDesc?: string
  functions?: number[]
}

export const roleLevelMap = {
  1: 'ROLE_LEVEL.ADMIN',
  2: 'ROLE_LEVEL.INSTITUTION',
  3: 'ROLE_LEVEL.AGENT',
  4: 'ROLE_LEVEL.MERCHANT',
  5: 'ROLE_LEVEL.STORE',
}
